import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-slate-800 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <div className="text-left">
                <div className="text-2xl font-serif font-bold tracking-tight text-white">
                  CAPITOL VIEW
                </div>
                <div className="text-xs font-light tracking-[0.3em] uppercase text-amber-400 -mt-1">
                  Stays
                </div>
              </div>
            </div>
            <p className="text-sm text-slate-400 mb-4 max-w-md">
              {companyInfo.tagline}
            </p>
            <p className="text-sm text-slate-400 mb-4">
              Providing exceptional short-term rentals in Washington DC since {companyInfo.yearEstablished}.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-sm">
                <Mail className="h-4 w-4" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-white transition-colors duration-200">
                  {companyInfo.email}
                </a>
              </div>
              <div className="flex items-center space-x-2 text-sm">
                <Phone className="h-4 w-4" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-white transition-colors duration-200">
                  {companyInfo.phone}
                </a>
              </div>
              {companyInfo.alternatePhone && (
                <div className="flex items-center space-x-2 text-sm">
                  <Phone className="h-4 w-4" />
                  <a href={`tel:${companyInfo.alternatePhone}`} className="hover:text-white transition-colors duration-200">
                    {companyInfo.alternatePhone}
                  </a>
                </div>
              )}
              <div className="flex items-center space-x-2 text-sm">
                <MapPin className="h-4 w-4" />
                <span>{companyInfo.address}</span>
              </div>
              {companyInfo.instagram && (
                <div className="flex items-center space-x-2 text-sm">
                  <Instagram className="h-4 w-4" />
                  <a 
                    href={`https://instagram.com/${companyInfo.instagram.replace('@', '')}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="hover:text-white transition-colors duration-200"
                  >
                    {companyInfo.instagram}
                  </a>
                </div>
              )}
              <div className="flex items-center space-x-2 text-sm">
                <Facebook className="h-4 w-4" />
                <a 
                  href="https://www.facebook.com/profile.php?id=61575537046498" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors duration-200"
                >
                  Capitol View Stay
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-white transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/properties" className="text-sm hover:text-white transition-colors duration-200">
                  Properties
                </Link>
              </li>
              <li>
                <Link to="/properties" className="text-sm hover:text-white transition-colors duration-200">
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-white transition-colors duration-200">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Resources
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/local-guide" className="text-sm hover:text-white transition-colors duration-200">
                  Local Guide
                </Link>
              </li>
              <li>
                <Link to="/house-rules" className="text-sm hover:text-white transition-colors duration-200">
                  House Rules & Policies
                </Link>
              </li>
              <li>
                <Link to="/guest-resources" className="text-sm hover:text-white transition-colors duration-200">
                  Guest Resources & QR Codes
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-white transition-colors duration-200">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-slate-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-slate-400">
              &copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-sm text-slate-400 hover:text-white transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-slate-400 hover:text-white transition-colors duration-200">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;